import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
export default class ProductTurnover extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      turnover: [],
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.product !== this.props.product) {
      this.load();
    }
  }

  load = async () => {
    this.setState({ pending: true });
    let turnover = await this.context.api.qa("/product/turnover/list", {
      filter: { product: this.props.product },
    });
    this.setState({ pending: false, turnover });
  };

  render() {
    const { item } = this.props;
    const { pending, turnover } = this.state;
    return (
      <Modal size="lg" show onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title className="w-100">
            <div className="d-flex justify-content-between align-items-center">
              <div>{item.label}</div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Blocker on={pending} hAuto>
            <table className="table">
              <thead>
                <tr>
                  <th>Дата, время</th>
                  <th>Документ</th>
                  <th>Поступление</th>
                  <th>Списание</th>
                </tr>
              </thead>
              <tbody>
                {turnover.map((item, idx) => {
                  let line = item || {};
                  let doc = line.document || {};
                  let datetime = line.datetime ? new Date(line.datetime) : {};
                  return (
                    <tr key={idx}>
                      <td>{datetime.toLocaleString()}</td>
                      <td>
                        <Link to={`/workdoc/any/any/${line.document}/`}>
                          {line.label}
                        </Link>{" "}
                      </td>
                      <td>{line.credit}</td>
                      <td>{line.debit}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Blocker>
        </Modal.Body>
      </Modal>
    );
  }
}
